import { snakeCase } from 'lodash';
import localStore from 'library/local-storage';

const ls = {
  get(key, defaultVal = null) {
    const value = localStore(snakeCase(key));
    return value !== null && value !== undefined ? value : defaultVal;
  },

  set(key, val) {
    return localStore(snakeCase(key), val);
  },

  remove(key) {
    return localStore.remove(snakeCase(key));
  },

  removeByGlobalKey(key) {
    return localStore.removeByGlobalKey(snakeCase(key));
  },
};

export { ls };



// WEBPACK FOOTER //
// ./src/services/ls.js